export function getStatusColor(status) {
  const classes = new Map([
    ['Distribuído', 'bg-[#DEFFE0] text-[#008E0A]'],
    ['Distribuir', 'bg-[#FFF1E4] text-[#EE750E]'],
    ['Não enviado', 'bg-[#FFE9E7] text-[#FF1F00]'],
    ['Aprovado', 'bg-[#DEFFE0] text-[#008E0A]'],
    ['Recusado', 'bg-[#FFE9E7] text-[#FF1F00]'],
    ['estornado', 'bg-[#FFE9E7] text-[#FF1F00]'],
    ['pago', 'bg-[#DEFFE0] text-[#008E0A]'],
    ['enviado', 'bg-[#DEFFE0] text-[#008E0A]'],
    ['rejeitado', 'bg-[#FFE9E7] text-[#FF1F00]'],
    ['aprovado', 'bg-[#DEFFE0] text-[#008E0A]'],
    ['Cancelado', 'bg-[#FFE9E7] text-[#FF1F00]'],
    ['Ativo', 'bg-[#DEFFE0] text-[#008E0A]'],
    ['Inadimplente', 'bg-[#FFECEC] text-[#830D00]'],
  ])
  return classes.get(status) || 'bg-blue-200 text-black'
}

export function getStatus(status) {
  const phrase = new Map([
    ['started', 'Em progresso'],
    ['done', 'Concluído'],
    ['canceled', 'Cancelado'],
    ['active', 'Ativo'],
    ['overdue', 'Inadimplente'],
  ])
  return phrase.get(status) || 'Concluído'
}

export const getCreditCardImg = (card) => {
  const imgs = new Map([
    ['Mastercard', '/img/mastercard.png'],
    ['Visa', '/img/visa.png'],
  ])
  return imgs.get(card) || '/img/creditCard.png'
}

export function convertToJsonArray(data) {
  const jsonArray = []
  for (const key in data) {
    jsonArray.push({ id: key, name: data[key] })
  }
  return jsonArray
}

export const addClassesLinked = (classes) => {
  const classesLinkeds = []
  classes.forEach((classObj) => {
    if (classObj.linkeds && Array.isArray(classObj.linkeds)) {
      classesLinkeds.push(...classObj.linkeds)
    }
  })

  const allClasses = [...classes, ...classesLinkeds]
  const { classesWithoutRepeat } = dontRepeatClass(allClasses)

  return { classesWithoutRepeat, classesLinkeds }
}

export const dontRepeatClass = (classes) => {
  const classesWithoutRepeat = []

  classes.forEach((classe) => {
    const alreadyExists = classesWithoutRepeat.some((cl) => cl.id === classe.id)
    !alreadyExists && classesWithoutRepeat.push(classe)
  })

  return { classesWithoutRepeat }
}

export function formatCurrency(value) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value)
}

export function formatDate(dateString) {
  const date = new Date(dateString)
  return date.toLocaleDateString('pt-BR')
}

export function formatDateToApi(date) {
  const myDate = formatDate(date)
  const [day, month, year] = myDate.split('/')
  return `${year}-${month}-${day}`
}

export function showDateInWords(index, startWeek) {
  const startDate = new Date(startWeek)
  const date = new Date()
  const days = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']

  date.setTime(startDate.getTime() + 1000 * 60 * 60 * 24 * (index - 1))
  return `${date.getDate()}/${date.getMonth() + 1}, ${days[date.getDay()]}`
}

export function showDate(index, startWeek) {
  const startDate = new Date(startWeek)
  const date = new Date()

  date.setTime(startDate.getTime() + 1000 * 60 * 60 * 24 * (index - 1))
  return formatDate(date)
}

export function getTime(date) {
  const myDate = new Date(date)
  const time = `${myDate.getHours()}:${
    myDate.getMinutes() === 0 ? myDate.getMinutes() + '0' : myDate.getMinutes()
  }`
  return time
}

export function orderedMaterial(materials) {
  return materials.map((objeto) => ({
    id: objeto.acm_id,
    order: objeto.acm_order,
    subcategories: objeto.sub.map((sub) => ({
      id: sub.asm_id || null,
      order: sub.asm_order || 0,
    })),
  }))
}

export function getDayInPtBr(day) {
  const classes = new Map([
    ['sunday', 'Dom'],
    ['monday', 'Seg'],
    ['tuesday', 'Ter'],
    ['wednesday', 'Qua'],
    ['thursday', 'Qui'],
    ['friday', 'Sex'],
    ['saturday', 'Sáb'],
  ])
  return classes.get(day) || 'Dom'
}

export function getPlanningTime(currentTime) {
  const [hour, minutes,] = currentTime.split(":")
  let time = ''
  if(hour !== '00') {
    time = time + `${hour[0] === '0' ? hour[1] : hour}h`
  }
  if(minutes !== '00') {
    time = time + `${minutes[0] === '0' ? minutes[1] : minutes}min`
  }
  return time
}
